<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <div class="summary-popup">
    <form [formGroup]="locationSummaryForm" class="form-wrapper">
      <ion-row>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <div class="form-group form-group-lg no-margin">
            <label class="big-label">{{ CONSTS.LABEL }} </label>
          </div>
          <app-form-date-picker
            [icon]="IMAGES.CALENDAR"
            [customClass]="'report-date-picker'"
            [minDate]="minDate"
            [maxDate]="maxDate"
            formControlName="date"
          ></app-form-date-picker>
        </ion-col>
        <ion-col
          size="12"
          size-sm="6"
          size-md="6"
          size-lg="6"
          size-xl="12"
          class="report-format-container"
        >
          <app-report-format
            [radioButtonValue]="locationSummaryForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
        </ion-col>
      </ion-row>
    </form>
  </div>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="summary"
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasTotalRow]="true"
  [hasSingleSubHeaderView]="false"
>
  @if (locationSummaryReport && locationSummaryReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION_CODE }}
            {{ locationSummaryReport.response.locationCode }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.LOCATION_NAME }}
            {{ locationSummaryReport.response.locationName }}
          </td>
          <td>
            {{ locationSummaryReport.response.date }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  <ng-container total-row>
    @if (locationSummaryReport && locationSummaryReport.response) {
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">{{ PDF_REPORT.FOOTER.TOTAL }}</td>
          <td class="pdf-total-cell"></td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalStops }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalDeliveryStopsNET }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalDeliveryPkgsNET }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalPickupStopsNET }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalPickupPkgsNET }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalMissedPickup }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalMissedDelStop }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalMissedDelPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalSendAgainCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalSendAgainPaid }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalNetCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalOffload }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalOpen }}
          </td>
          <td class="pdf-total-cell">
            {{ locationSummaryReport.response.totalOther }}
          </td>
        </tr>
      </table>
    }
  </ng-container>
</app-pdf-report-generator>
